import { t } from '@avalara/bat-apps-shared/i18n';
import { useSelector } from 'react-redux';

import conf from '../../conf';
import { getAuthLogin } from '../../lib/helpers';
import { getEsbConfig, getEsbPartnerName } from '../../selectors/esb';
import ExternalLink from '../external-link';

const AlreadyHaveAccount = () => {
  const esbPartnerName = useSelector(getEsbPartnerName);
  const dataRefEsbPartnerName = esbPartnerName.replace(' ', '').toLowerCase();

  const esbConfig = useSelector(getEsbConfig);
  const showSignIn = esbConfig?.isAddOnEnabled || false;

  return (
    <>
      {showSignIn ? (
        <>
          {t('client.general.already-have-an-account')}{' '}
          <span data-ref={`esb-signup.sign-in-link.${dataRefEsbPartnerName}`}>
            <a href={getAuthLogin()}>{t('client.general.sign-in')}</a>
          </span>
        </>
      ) : (
        <span>
          {t('client.general.already-have-an-account')}{' '}
          <ExternalLink href={conf.AA_URL}>{t('client.general.contact-your-account-manager')}</ExternalLink>{' '}
          {t('client.general.contact-your-account-manager-to-connect-to-partner', { partnerName: esbPartnerName })}.
        </span>
      )}
    </>
  );
};

export default AlreadyHaveAccount;
